/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { InvoiceConfiguration } from './components';

export interface InvoiceConfigurationPageProps {
    currentPath?: string;
}

export const InvoiceConfigurationPage: React.FC<InvoiceConfigurationPageProps> = ({ currentPath }) => (
    <TabBarBodyLayout>
        <InvoiceConfiguration stateId={currentPath} />
    </TabBarBodyLayout>
);
